import React from "react";

const PlanTableCellHour = ({ existingTime, timeIndex, setTime }) => {
    const timechange = (value) => {
        setTime(value, timeIndex)
    }

    return (
        <td scope="row" className="font-medium text-sm">
            <input type="text" className=" w-full min-w-[110px] max-w-[110px] py-3 px-2 xl:px-4 bg-transparent w-full font-semibold text-medium placeholder:text-xs" placeholder="Unesi vreme" value={existingTime || ''} onChange={(e) => timechange(e.target.value, timeIndex)} />
        </td>
    );
};

export default PlanTableCellHour;



